module.exports = __webpack_public_path__ + "media/images/emblems/Sigriswil-coat_of_arms-159a5edf3ddf90edc125b27ddb4f034f.svg";